import { motion } from 'framer-motion'

/**
 * Hero section component with integrated navigation
 * Features: Navigation bar, animated text, call-to-action buttons, background graphics
 */
const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  }

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  }

  return (
    <div className="hero wf-section" style={{ 
      margin: 0, 
      padding: 0, 
      position: 'relative',
      marginTop: '-80px',
      paddingTop: '80px',
      paddingBottom: '50px'
    }}>
      {/* div-block-20 with background overlay */}
        <div 
          className="div-block-20 w-full"
          style={{ 
            backgroundColor: '#030710',
            backgroundImage: `linear-gradient(230deg, rgba(3, 205, 205, .09) 58%, rgba(85, 51, 128, 0))`,
            backgroundPosition: '0 0',
            backgroundSize: 'auto',
            backgroundRepeat: 'repeat',
            height: '100vh',
            margin: 0,
            padding: 0,
            position: 'absolute',
            top: '-80px',
            left: 0,
            right: 0,
            bottom: 0
          }}
        >
          {/* Hero image with opacity overlay */}
          <div 
            className="hero-background-image absolute inset-0"
            style={{
              backgroundImage: `url('/desktop_hero-p-130x130q80.png')`,
              backgroundPosition: '100% 0',
              backgroundSize: '65%',
              backgroundRepeat: 'no-repeat',
              opacity: '0.6',
              zIndex: 1,
              top: '80px'
            }}
          ></div>
        </div>
        
        {/* Content container to maintain height */}
        <div style={{ height: 'auto', position: 'relative', zIndex: 2, paddingBottom: 0 }}>
          {/* Container for hero content - aligned with navigation */}
          <div className="hero-container container overflow-visible w-full relative z-10" style={{ 
            maxWidth: '1280px', 
            margin: '0 auto',
            padding: '0 16px'
          }}>
          <div className="hero-wrapper" style={{ marginTop: '120px' }}>
            <motion.div
              className="hero__content text-left max-w-3xl"
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
          {/* Main Title */}
          <motion.div variants={itemVariants}>
            {/* KARDS.TECH with h2.yellow styling */}
            <h2 
              className="hero-brand-title block mb-6"
              style={{
                fontSize: '3.375rem', // 54px
                color: '#e5ff47',
                textTransform: 'none',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                fontFamily: 'Sequel100-65, sans-serif',
                fontWeight: 'bold',
                lineHeight: '1.4em',
                marginTop: 0,
                marginBottom: '24px'
              }}
            >
              KARDS.TECH
            </h2>
            
            {/* THE FIRST SAAS DEFI CASINO with h1 styling */}
            <h1 
              className="hero-main-title block"
              style={{
                marginTop: 0,
                marginBottom: 0,
                fontFamily: 'Sequel100-65, sans-serif',
                color: '#fff',
                fontSize: '3.375rem', // 54px
                lineHeight: '1.4em',
                textTransform: 'uppercase',
                fontWeight: 'normal'
              }}
            >
              THE FIRST SAAS<br />
              DEFI CASINO
            </h1>
          </motion.div>

          {/* Subtitle */}
          <motion.div 
            className="hero-text"
            variants={itemVariants}
          >
            <p className="hero-subtitle paragraph text-lg md:text-xl text-gray-300 mb-8 max-w-2xl leading-relaxed text-left">
              The most advanced decentralized SaaS casino platform, We provide with end-to-end software and tools 
              that were previously only available in casinos.
            </p>
          </motion.div>

          {/* CTA Buttons */}
          {/* <motion.div 
            className="flex flex-col sm:flex-row gap-4 justify-start items-start"
            variants={itemVariants}
          >
            <motion.button
              className="btn-primary text-lg px-8 py-4"
              whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(0,0,0,0.2)" }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              Get Started Free
            </motion.button>
            
            <motion.button
              className="btn-outline text-lg px-8 py-4"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              Learn More
            </motion.button>
          </motion.div> */}

          {/* Stats or Features Preview */}
          <motion.div 
            className="hero-stats mt-16 mb-0 flex flex-wrap gap-8 justify-center md:justify-start"
            variants={itemVariants}
          >
            <div className="hero-stat text-center md:text-left">
              <div className="hero-stat-number text-3xl font-bold text-neon-green mb-2">100%</div>
              <div className="hero-stat-label text-gray-300">Decentralized</div>
            </div>
            <div className="hero-stat text-center md:text-left">
              <div className="hero-stat-number text-3xl font-bold text-neon-blue mb-2">24/7</div>
              <div className="hero-stat-label text-gray-300">Support</div>
            </div>
            <div className="hero-stat text-center md:text-left">
              <div className="hero-stat-number text-3xl font-bold text-neon-yellow mb-2">10+</div>
              <div className="hero-stat-label text-gray-300">Languages</div>
            </div>
          </motion.div>
            </motion.div>
          </div>
          
          {/* Scroll Indicator */}
          <motion.div 
            className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, y: [0, 10, 0] }}
            transition={{ 
              opacity: { delay: 1, duration: 0.5 },
              y: { duration: 2, repeat: Infinity, delay: 1.5 }
            }}
          >
            <div 
              className="w-6 h-10 rounded-full flex justify-center"
              style={{
                border: '2px solid rgba(57, 255, 20, 0.5)',
                background: 'transparent'
              }}
            >
              <motion.div 
                className="w-1 h-3 rounded-full mt-2"
                style={{ background: 'rgba(57, 255, 20, 0.7)' }}
                animate={{ y: [0, 12, 0] }}
                transition={{ duration: 2, repeat: Infinity, delay: 1.5 }}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default Hero
